import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

export const exportToPDF = ({ title, subtitle, columns, rows, summary }) => {
  const doc = new jsPDF({ orientation: "landscape" });
  doc.setFontSize(16);
  doc.text(title, 14, 18);
  if (subtitle) {
    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text(subtitle, 14, 25);
  }
  autoTable(doc, {
    startY: subtitle ? 30 : 24,
    head: [columns.map((c) => c.header)],
    body: rows.map((r) => columns.map((c) => r[c.key] ?? "")),
    styles: { fontSize: 9 },
    headStyles: { fillColor: [37, 99, 235] },
  });
  if (summary && summary.length) {
    const y = doc.lastAutoTable.finalY + 8;
    doc.setFontSize(10);
    doc.setTextColor(20);
    summary.forEach((s, i) => doc.text(`${s.label}: ${s.value}`, 14, y + i * 6));
  }
  doc.save(`${title.replace(/\s+/g, "_")}.pdf`);
};

export const exportToExcel = ({ title, rows }) => {
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Datos");
  XLSX.writeFile(wb, `${title.replace(/\s+/g, "_")}.xlsx`);
};

export const fmtMoney = (n) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", minimumFractionDigits: 2 }).format(n || 0);

export const fmtPct = (n) => `${(n || 0).toFixed(2)}%`;
export const fmtNum = (n, d = 2) => (n || 0).toFixed(d);
